import { format, parseISO } from 'date-fns';

export const CARD = 'bg-white rounded-xl border border-gray-200 shadow-sm';

export const STATUSES = [
  'processing',
  'retrying',
  'admitted',
  'failed',
  'dead_lettered',
];

export const isPendingStatus = (status) =>
  status === 'processing' || status === 'retrying';

export const STATUS_LABELS = {
  processing: 'Processing',
  retrying: 'Retrying',
  admitted: 'Admitted',
  failed: 'Failed',
  dead_lettered: 'Needs review',
};

export const STATUS_HELP = {
  processing: 'Received and being admitted now.',
  retrying:
    'A temporary error (forms or the database was unavailable). Retried every minute for about an hour.',
  admitted: 'An active member of the cohort.',
  failed: 'Not admitted for a reason that needs fixing first.',
  dead_lettered:
    'Gave up after an hour of retries, or the message was unreadable.',
};

export const STATUS_STYLES = {
  processing: 'bg-gray-100 text-gray-700',
  retrying: 'bg-amber-50 text-amber-700',
  admitted: 'bg-green-50 text-green-700',
  failed: 'bg-red-50 text-red-700',
  dead_lettered: 'bg-red-50 text-red-700',
};

export const OUTCOME_LABELS = {
  created: 'New LMS account, onboarding email sent',
  linked_existing: 'Existing LMS account added to the cohort',
  already_member: 'Already in the cohort, nothing changed',
};

// What staff can do about each failure (the server sends reason_text).
export const REASON_FIXES = {
  cohort_not_found:
    'If the cohort was deleted or deactivated in the LMS, restore it, then replay. A wrong cohort on an open collection is locked on forms and can’t be fixed from the LMS, so ask the forms team.',
  person_not_found: 'Check the applicant on forms.',
  missing_email: 'Add their email on forms, then replay.',
  duplicate_conflict:
    'Their email belongs to an LMS account that isn’t a student. Resolve that account, then replay.',
  invalid_data: 'Correct their details on forms, then replay.',
};

export const reasonLabel = (admission) =>
  admission?.reason_text || admission?.reason || null;

export const formatDateTime = (value) =>
  value ? format(parseISO(value), 'd MMM yyyy, HH:mm') : '–';

export const shortId = (id) =>
  id && id.length > 12 ? `${id.slice(0, 8)}…` : id || '–';

export const cohortLabel = (cohort) => {
  if (!cohort) return '–';
  if (cohort.name) return cohort.name;
  return cohort.id ? `Missing cohort (${shortId(cohort.id)})` : '–';
};

// Date inputs give local days (staff are in EAT). Send their bounds as
// RFC 3339 with the local offset, so a day means the staff member's day.
export const dayStart = (day) =>
  day ? format(new Date(`${day}T00:00:00`), "yyyy-MM-dd'T'HH:mm:ssxxx") : '';

export const dayEnd = (day) =>
  day ? format(new Date(`${day}T23:59:59`), "yyyy-MM-dd'T'HH:mm:ssxxx") : '';
